import type { ContentFolder } from 'services/folders/entities';

export const ROOT_ID = 'root';
type FolderId = string;
export type FolderPathItem = { id: FolderId; label: string };

export function findFolderById(folder: ContentFolder, id: FolderId): ContentFolder | undefined {
  if (folder.id === id) return folder;
  for (const sub of folder.subfolders) {
    const found = findFolderById(sub, id);
    if (found) return found;
  }
  return undefined;
}

function findPathToFolder(folder: ContentFolder, targetId: FolderId): FolderPathItem[] {
  const { id, subfolders, name: label } = folder;

  if (id === targetId) return [{ id: id ?? ROOT_ID, label }];

  for (const sub of subfolders) {
    const subPath = findPathToFolder(sub, targetId);
    if (subPath.length) return [{ id: id ?? ROOT_ID, label }, ...subPath];
  }
  return [];
}

export function getBreadcrumbs(rootFolder: ContentFolder, currentFolderId: FolderId, rootLabel: string): FolderPathItem[] {
  if (currentFolderId === ROOT_ID) {
    return [{ id: ROOT_ID, label: rootLabel }];
  }

  const currentFolder = findFolderById(rootFolder, currentFolderId);
  if (currentFolder == null) {
    return [{ id: ROOT_ID, label: rootLabel }];
  }

  const pathFromRoot = findPathToFolder(rootFolder, currentFolder.id ?? '');
  if (pathFromRoot.length === 0) {
    return [{ id: ROOT_ID, label: rootLabel }];
  }

  return pathFromRoot.map((segment, index) => (index === 0 ? { id: ROOT_ID, label: rootLabel } : segment));
}

export function removeEmptySubfolders(folder: ContentFolder): ContentFolder {
  const processedSubfolders = folder.subfolders
    .map(removeEmptySubfolders)
    .filter((sub) => sub.contents.length > 0 || sub.subfolders.length > 0);
  return {
    ...folder,
    subfolders: processedSubfolders,
  };
}
